import styled from 'styled-components'

import { Colors } from 'common-constants/colors'
import { media } from 'components/presentational'
import { RouterLink } from 'components/presentational/link'

export const WrapperButton = styled(RouterLink)`
  display: none;
  padding: 7px 10px 7px 12px;
  border-radius: 0 0 8px 8px;
  background-color: ${Colors.backgroundLight};
  justify-content: space-between;
  align-items: center;
  color: ${Colors.specialGray};
  font-size: 15px;
  line-height: 1.13;
  width: 100%;
  box-sizing: border-box;

  ${media.tablet`
    display: flex;
  `}
`
